module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/preview-ef8d93f1cc759403845bac8f3bd18472.png";